import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

/**
 * 1. detect scrolling, add/remove `is-scrolled` class to the wrapper
 *    (so we can change header height)
 * 2. scroll to top when the location changes
 */
export class ScrollManager extends Component {
  static propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired
    }).isRequired,
    children: PropTypes.node.isRequired
  };

  state = {
    scrolled: false
  };

  render() {
    const { scrolled } = this.state;
    return (
      <div className={scrolled ? 'is-scrolled' : ''}>{this.props.children}</div>
    );
  }

  // scroll to top when path changes
  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      window.scrollTo(0, 0);
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  // finding if the page is scrolled by 10px
  handleScroll = () => {
    this.setState({ scrolled: window.scrollY > 10 });
  };
}

export default withRouter(ScrollManager);



// WEBPACK FOOTER //
// ./src/components/Wrappers/ScrollManager.js